<template>
	<v-row>
		<v-col :cols="6">
			<v-text-field
				:label="$t('docs.searchbar.search')"
				v-model="currentSearch"
				:rules="rules"
				:disabled="disabled"
				ref="input"
			/>
		</v-col>
		<v-col :cols="6">
			<v-btn class="controller-header__searchbar__button" @click="search" :disabled="disabled">
				<v-icon>mdi-magnify</v-icon>
			</v-btn>
			<v-btn v-if="searchMode" class="controller-header__searchbar__button" @click="resetSearch">
				{{ $t('docs.searchbar.resetSearch') }}
			</v-btn>
		</v-col>
	</v-row>
</template>
<script>

export default {
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		searchMode: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			currentSearch: '',
			rules: [
				value => !!value || this.$t('docs.searchbar.required'),
				value => !!value & value.length >= 3 || this.$t('docs.searchbar.min3Character')
			]
		};
	},
	methods: {
		search () {
			this.$emit('search', this.currentSearch);
		},
		reset () {
			this.$refs.input.reset();
		},
		resetSearch () {
			this.$emit('reset-search');
		}
	}
};
</script>

<style lang="scss" scoped>
</style>
